import { HttpClient } from '@angular/common/http';
import { inject, Inject, Injectable } from '@angular/core';
import { catchError, Observable, of } from 'rxjs';
import { AddCartBulkInput, AddCartItemInput, Coupon, UpdateCartItemInput, WishlistInput } from '../../inputs';
import { Checkout, SubmitResponse } from '../../models';
import { ActiveUserService } from '@sgm-frontend/core';
import { HttpService } from './http.service';
import { Cart } from '../../models/product/cart.model';


@Injectable({
  providedIn: 'root'
})
export class CartService extends HttpService<AddCartItemInput | UpdateCartItemInput | Coupon | WishlistInput | AddCartBulkInput, Cart | Checkout> {
  private readonly activeUserService = inject(ActiveUserService);

  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'cart');
  }

  getCart(): Observable<Cart> {
    return this.getAll('') as Observable<Cart>;
  }
  getCheckout(): Observable<Checkout> {
      return this.getAll('checkout') as Observable<Checkout>;
    }

  addToCart(cartItem: AddCartItemInput): Observable<SubmitResponse> {
    return this.create(cartItem, 'item');
  }
   addToCartBulk(cartItem: AddCartBulkInput): Observable<SubmitResponse> {
    return this.create(cartItem, 'item/bulk');
  }

  updateCart(cartItem: UpdateCartItemInput): Observable<SubmitResponse> {
    return this.update(cartItem, 'item');
  }

  deleteItemFromCart(productId: number): Observable<SubmitResponse> {
    return this.delete(productId, 'item');
  }
  deleteOutOfstockItemFromCart(): Observable<SubmitResponse> {
    return this.delete('all');
  }
  clearUserCart(): Observable<SubmitResponse> {
    return this.delete('');
  }
  addCouponCart(coupon: Coupon): Observable<SubmitResponse> {
    return this.create(coupon, 'apply-coupon');
  }
  removeCouponCart(): Observable<SubmitResponse> {
    return this.delete('remove-coupon');
  }
   addToWishlist(input: WishlistInput , wishlistCategoryId : string): Observable<SubmitResponse> {
      return this.create(input,wishlistCategoryId).pipe(catchError((error) => of(error)));
    }

}
